import styles from './MembershipSteps.module.scss';
import Button, { ButtonType } from '@/components/Button/Button';
import Text from '@/components/Text/Text';

interface IMembershipSteps {
  title: string,
  subtitle?: string;
  button?: {
    id: number;
    title: string;
    type: ButtonType;
    link: string;
    iconName?: string;
  },
  steps: {
    id: number,
    stepLabel: string,
    description: string,
  }[]
}

const MembershipSteps = ({ data }: { data: IMembershipSteps }) => (
  <section className={styles.membershipSteps}>
    <div className={styles.titleContainer}>
      <Text
        tag='h3'
        className={styles.title}
      >
        {data.title}
      </Text>
      {data.subtitle && (
        <Text
          tag='p'
          className={styles.subtitle}
        >
          {data.subtitle}
        </Text>
      )}
    </div>

    <ul className={styles.membershipSteps_list}>
      {data.steps.map((step) => (
        <li
          className={styles.membershipSteps_card}
          key={step.id}
        >
          <Text
            tag='h5'
            className={styles.cardTitle}
          >
            {step.stepLabel}
          </Text>
          <p>{step.description}</p>
        </li>
      ))}
    </ul>
    {data.button && (
      <div className={styles.primaryButtonContainer}>
        <Button
          type={data.button.type}
          href={data.button.link}
          iconName={data.button.iconName}
        >
          {data.button.title}
        </Button>
      </div>
    )}
  </section>
);

export default MembershipSteps;
